module.exports = __webpack_public_path__ + "static/media/trophy.ae4182c3.svg";